let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ccyGR")).then(() => parcelRequire('g3ED8'));